var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStoreCardBg = function SvgStoreCardBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 202,
    height: 90,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "store-card-bg_svg__a",
    width: 202,
    height: 90,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 202,
    height: 90,
    fill: "#D9D9D9",
    rx: 8
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    mask: "url(#store-card-bg_svg__a)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m107.898-128.984-6.28 218.554-9.83-218.554zM124.284-128.984 102.233 89.57l35.978-218.554zM155.142-128.984 102.745 89.57l69.331-218.554h-16.933999999999997M103.425 89.57l86.126-218.554h19.118zM212.22-100.035 104.314 89.558 212.22-70.266zM105.305 89.57 212.22-43.78v18.025zM106.944 89.541 212.22-11.279V4.558zM212.22 16.335 109.528 89.541 212.22 25.654zM212.22 36.51 112.933 89.54l99.287-43.61zM212.22 54.943l-92.545 34.582 92.545-25.84zM134.901 89.492l77.319-11.507V70.51zM78.933-129l22.055 218.554L65.005-129zM48.075-129l52.401 218.554L31.145-129h16.93M99.792 89.554 13.665-129H-5.452zM-9-100.051 98.903 89.541-9-70.287zM97.915 89.554-9-43.796v18.025zM96.277 89.525-9-11.3V4.54zM-9 16.319 93.688 89.525-9 25.638zM-9 36.493l99.284 53.032L-9 45.915zM-9 54.927l92.541 34.582L-9 63.665zM68.319 89.472-9 77.969v-7.476z"
  }))));
};
export default SvgStoreCardBg;